module.exports = __webpack_public_path__ + "img/diagram-lean-canvas.b47fd188.svg";